import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsGastro(tenant: Tenant): Faq[] {
	return [
		{
			question: "Kolik stojí vývoj objednávkových systémů, kioskových řešení nebo webových a mobilních aplikací?",
			answer:
				"Ceny nejjednodušších řešení začínají zhruba na 200–500 tisících Kč. V praxi se většina projektů pohybuje kolem 1 milionu Kč. Každou zakázku naceňujeme individuálně podle konkrétních požadavků a představ klienta.",
		},
		{
			question: "Jak dlouho vývoj na míru pro firmy z oblasti HORECA trvá?",
			answer:
				"Záleží na rozsahu projektu, typicky vývoj zabere 2 měsíce a více, větší projekty trvají i půl roku až rok.",
		},
		{
			question: "Co všechno dokážete digitalizovat nebo automatizovat v hotelu nebo restauraci?",
			answer:
				"Umíme digitalizovat objednávky, rezervace, skladové hospodářství, interní agendu nebo komunikaci. Výsledkem je méně chyb, méně papírování a větší přehled nad celým provozem.",
		},
		{
			question: "Jak to proběhne, když se s vámi budeme chtít pustit do spolupráce?",
			answer:
				"Nejprve zhodnotíme vaši situaci, potřeby a zjistíme, v jakém stádiu se nacházíte a jaké jsou vaše cíle. Pokud si společně odsouhlasíme podmínky spolupráce, pustíme se do práce. Sázíme na tzv. agilní vývoj, díky kterému projekt rozdělíme na menší fáze. Po dokončení této fáze společně doladíme detaily a spustíme základní verzi softwaru (tzv. MVP). Poté vám budeme k dispozici v rámci podpory a dalšího rozvoje systému.",
		},
		{
			question: "Jak se budeme podílet na vývoji zakázky a na rozhodování?",
			answer:
				"Záleží na domluvě. Buď můžete být součástí procesu na denní bázi, nebo projekt svěříte do rukou našeho produktového manažera v roli Product Ownera.",
		},
		{
			question: "Poskytujete technickou podporu i po dokončení projektu?",
			answer: "Ano. Naše podpora vám bude k dispozici po celou dobu používání softwaru nebo jiných služeb od Fastest.",
		},
		{
			question: "Když si od vás necháme vytvořit systém na míru, ukážete nám, jak ho používat?",
			answer: "Ano, po předání projektu rádi zaškolíme vás i vaše zaměstnance.",
		},
	];
}
